const ICON_MAP = {
  search: 'search',
  build: 'build',
  calendarExclamation: 'Calendar-exclamation',
  checkCircle: 'check-circle',
  check: 'check',
  chevronDown: 'Chevron-down',
  chevronLeft: 'Chevron-left',
  chevronRight: 'Chevron-right',
  chevronUp: 'Chevron-up',
  copy: 'copy',
  down: 'Down',
  download: 'Download',
  edit: 'edit',
  filePdf: 'file-pdf',
  file: 'file',
  hub: 'hub',
  importContacts: 'importcontacts',
  language: 'language',
  leftRight: 'Left-right',
  left: 'Left',
  list: 'List',
  liveTv: 'livetv',
  mail: 'mail',
  myLocation: 'mylocation',
  preview: 'preview',
  print: 'Print',
  right: 'Right',
  settings: 'Settings',
  signpost: 'signpost',
  up: 'Up',
  video: 'video',
  close: 'Close',
  xmarkCircle: 'xmark-circle'
}

const getIconName = key => {
  if (!key) return null
  if (ICON_MAP[key]) return ICON_MAP[key]
  return key
}

export { ICON_MAP, getIconName }

export default ICON_MAP
